// extracted by mini-css-extract-plugin
export default {"container":"no-results_container__MDRQf","heading":"no-results_heading__27ITV"};